module.exports = __webpack_public_path__ + "static/img/log_bot.15ebccb4.svg";